import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
import { useSelector } from 'store';
import { DASHBOARD_PATH } from 'config';
import { GuardProps } from 'types';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

const GuestGuard = ({ children }: GuardProps) => {
    const { isLoggedIn } = useSelector((state) => state.account);
    const { isAppStarting } = useSelector((state) => state.appForm);
    const navigate = useNavigate();

    useEffect(() => {
        if (isLoggedIn) {
            navigate(DASHBOARD_PATH, { replace: true });
        }
    }, [isLoggedIn, navigate, isAppStarting]);

    return children;
};

export default GuestGuard;
